import { createRouter, createWebHistory } from 'vue-router'
import MainView from '../views/MainView.vue'
import Login from '../components/Login.vue'
import TodoList from '../subView/todolist/TodoList.vue'
import Abhs from '../subView/abhs/Abhs.vue'
import Gallery from '../subView/abhs/Gallery.vue'
import Practice from '../subView/abhs/Practice.vue'
import Memorization from '../subView/abhs/Memorization.vue'
import Edit from '../subView/abhs/Edit.vue'
// import Graph from '../subView/graph/Graph.vue'
import Graph from '../subView/graph/KnowledgeGraph.vue'
import Ranking from '../subView/ranking/Ranking.vue'
import FileManage from '../subView/fileManage/FileManage.vue'
import TimeTracker from '../subView/todolist/components/TimeTracker.vue'
import InfoGather from '../subView/infoGather/infoGather.vue'

const routes = [
    {
        path: '/',
        name: 'MainView',
        component: MainView
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/todo',
        name: 'TodoList',
        component: TodoList
    },
    {
        path: '/abhs',
        name: 'Abhs',
        component: Abhs
    },
    {
        path: '/abhs/galleryE',
        name: 'GalleryE',
        component: Gallery
    },
    {
        path: '/abhs/galleryC',
        name: 'GalleryC',
        component: Gallery
    },
    {
        path: '/abhs/practice',
        name: 'Practice',
        component: Practice
    },
    {
        path: '/abhs/memorization',
        name: 'Memorization',
        component: Memorization
    },
    {
        path: '/abhs/edit',
        name: 'Edit',
        component: Edit
    },
    {
        path: '/graphWeb',
        name: 'GraphWeb',
        component: Graph
    },
    {
        path: '/filemanage',
        name: 'FileManage',
        component: FileManage
    },
    // 重定向规则，处理可能的旧路径引用
    {
        path: '/todolist',
        redirect: '/todo'
    },
    {
        path: '/ranking',
        name: 'Ranking',
        component: Ranking
    },
    {
        path: '/timetracker',
        name: 'TimeTracker',
        component: TimeTracker
    },
    {
        path: '/infogather',
        name: 'InfoGather',
        component: InfoGather
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router